<template>
    <div class="container-fluid">
        <div class="row align-items-center">
            <div class="col-lg">
                <div class="sub-navigation-header">
                    <i class="material-icons sub-navigation-header-icon">{{ icon }}</i>
                    <span class="sub-navigation-header-title">{{ title }}</span>
                    <div class="sub-navigation-after-header">
                        <slot name="after-title"></slot>
                    </div>
                </div>
            </div>
            <div class="col-lg-5 text-right">
                <slot name="actions"></slot>
            </div>
        </div>
        <div class="row align-items-center">
            <div class="col-lg"><hr class="mb-4"></div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        },
        icon: {
            type: String,
            required: true
        }
    }
}
</script>

<style lang="scss" scoped>
    .sub-navigation-header {
        .sub-navigation-header-title {
            font-size: 1.5rem;
            vertical-align: middle;
            margin-left: 0.5rem;
        }

        .sub-navigation-header-icon {
            font-size: 2rem;
            vertical-align: middle;
        }

        .sub-navigation-after-header {
            display: inline-block;
        }
    }
</style>